import React, { Component } from 'react';

import Checkbox from 'components/checkbox/Checkbox';
import { updateAttributeOnDocument } from 'util/pouchActions';

class PouchCheckbox extends Component {
  onCheck = (value) => {
    updateAttributeOnDocument(this.props.meetId, this.props.documentId, this.props.name, value);
  };

  render() {
    return (
      <Checkbox label={this.props.label} onCheck={this.onCheck} value={this.props.value} />
    );
  }
}

export default PouchCheckbox;
